<a (click)="toggle()" id="{{testId}}">
  <span class="nav-caret">
    <i class="fa fa-solid fa-1x fa-caret-down"></i>
  </span>
  <!-- TODO
       Implement badges as a component. Badges count/color probably will be fed via web socket or SSE
      <span class="nav-label">
        <b class="label rounded label-sm warn">5</b>
      </span>
   -->
  <span class="nav-icon" *ngIf="icon">
    <i class="fa fa-light {{ icon }}"></i>
  </span>
  <span class="nav-text">{{ name }}</span>
</a>

<ng-content></ng-content>

